import * as React from "react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";
import LanguageSelector from "./LanguageSelector/LanguageSelector"
import paperBackFirstImg from "../assets/images/masks/paper-back-1.svg";
import paperBackSecondImg from "../assets/images/masks/paper-back-2.svg";

import { MainListItems } from "./ListItems";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import { Backdrop } from "@mui/material";
import logoMini from "../assets/images/logo-mini.svg";
import CartHeader from "./CartHeader/CartHeader";
import { useDispatch, useSelector } from "react-redux";
import { setTokens } from "../redux/actions/tokenActions";
import logoWhite from "../assets/images/logo-white.svg";
import DarkLightMode from "./common/DarkLightMode/DarkLightMode";
import SettingsIcon from "@mui/icons-material/Settings";
import { setProfile } from "../redux/actions/cartActions";
import Branches from "./DashboardMain/Branches/Branches";
import {
  setAgencyArray,
  setBranchesArray,
  setSelectedBranchesString,
} from "../redux/actions/branchActions";
import Swal from "sweetalert2";
import { ChevronLeft } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, drawerWidth }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  marginLeft: drawerWidth,
  width: `calc(100% - ${drawerWidth}px)`,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, lightMode, drawerWidth }) => ({
  "& .MuiDrawer-paper": {
    backgroundColor: `rgba(${lightMode ? "254 254 254" : "30 30 30"} / 0.9)`,
    backgroundImage: `url(${paperBackSecondImg}), url(${paperBackSecondImg})`,
    backgroundSize: "50%, 50%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top, left bottom",
    backdropFilter: "blur(20px)",
    outline: 0,

    // backgroundColor: lightMode ? "#fefefe" : "#1e1e1e",
    color: "#ffffff",
    position: "fixed",
    top: 0,
    bottom: 0,
    whiteSpace: "nowrap",
    width: drawerWidth,
    height: "100%",
    zIndex: "99999",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(0),
      [theme.breakpoints.up("md")]: {
        width: theme.spacing(7),
      },
    }),
  },
}));

// TODO remove, this demo shouldn't need to reset the theme.

const CustomBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: 9999, // Bu, drawer'dan hemen önce yerleştirir.
  color: "#fff",
}));

export default function Dashboard({ open, setOpen, isMobile, setIsMobile }) {
  const token = useSelector((state) => state.token); // Filtrelenmiş ürünleri al
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin
  const [drawerWidth, setDrawerWidth] = React.useState(320);
  const profile = useSelector((state) => state.profile);
  const location = useLocation();
  const isDashboard = location.pathname === "/";

  const { t } = useTranslation()

  React.useEffect(() => {
    if (open) {
      setDrawerWidth(320);
    } else {
      if (isMobile) {
        setDrawerWidth(0);
      } else {
        setDrawerWidth(56);
      }
    }
  }, [open, isMobile]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const dispatch = useDispatch();
  // Resize event listener
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 999);
    };

    // Event listener'ı ekleyin
    window.addEventListener("resize", handleResize);

    // Cleanup function olarak event listener'ı kaldırın
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Bu useEffect'i sadece bileşen mount olduğunda çalıştırmak için boş bir bağımlılık dizisi verin.

  React.useEffect(() => {
    if (isMobile) {
      setOpen(false);
    } else {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);
  const theme = useTheme();

  const logOutFunc = async () => {
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    Swal.fire({
      icon: "info",
      title: `${t("loggingOut") + "..."}`,
      showConfirmButton: false,
      allowOutsideClick: false,
    });
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}auth/logout`,
        {
          refresh: token,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
            XRefreshToken: `${token}`, // Bearer token burada ekleniyor
            "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
          },
        }
      );
      dispatch(setTokens(null, null));
      dispatch(setProfile(null));
      dispatch(setSelectedBranchesString([]));
      dispatch(setBranchesArray([]));
      dispatch(setAgencyArray([]));
      localStorage.removeItem("profile");
      localStorage.removeItem("agency");
      localStorage.removeItem("branches-string");
      localStorage.removeItem("branches");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("loginUser");
      Swal.close();
      navigate("/login");
    } catch (error) {
      console.log(error);
      if (error.response) {
        // Sunucunun döndürdüğü hata yanıtı
        console.log("Error response:", error.response.data);
        console.log("Error status:", error.response.status);
        console.log("Error headers:", error.response.headers);
      } else {
        // Hata yanıtı alınamazsa
        console.log("Error message:", error.message);
      }
    }
  };

  const navigate = useNavigate();

  const [personShow, setPersonShow] = React.useState(false);
  const profileRef = React.useRef(null);
  // Dış tıklamaları kontrol etmek için bir fonksiyon
  const handleClickOutside = (event) => {
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setPersonShow(false);
    }
  };

  React.useEffect(() => {
    // Dış tıklamaları dinlemek için olay dinleyicisini ekleyin
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Component unmount edildiğinde olay dinleyicisini kaldırın
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box
      data-root-layout
      sx={{
        display: "flex",
        overflow: isMobile && open ? "hidden" : "auto",
        overflowX: "hidden",
        maxHeight: isMobile && open ? "100vh" : "auto",
      }}
    >
      <CssBaseline />
      <AppBar
        sx={{
          // backgroundColor: "#fffffe",
          backgroundColor: lightMode ? "#ffffff80" : "#000000bf",
          boxShadow: "unset",
          filter: "unset",
          "&:before": {
            content: '""',
            backdropFilter: "blur(6px)",
            backgroundColor:
              "rgba(var(--palette-background-defaultChannel), 0.8)",
            opacity: 1,
            visibility: "visible",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: -1,
            transition:
              "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), visibility 200ms cubic-bezier(0.4, 0, 0.2, 1)",
          },
        }}
        position="fixed"
        open={open}
        drawerWidth={drawerWidth}
      >
        <Toolbar
          sx={{
            // backgroundColor: lightMode ? "#fffffe" : "#1e1e1e",
            backgroundColor: "transparent",
            py: "8px",
            pr: "24px", // keep right padding when drawer closed
            pl: { xs: "64px", md: "24px" },
          }}
        >
          <Branches open={open} />

          <LanguageSelector />

          <DarkLightMode />

          {/* <Typography
                        component="h1"
                        variant="h6"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1 }}
                    >
                        Agency Portal
                    </Typography> */}
          {/* <Link to={"/payment/shop"}>Cart</Link> */}
          {/* {isMobile ? ( */}

          <CartHeader />

          {/* {profile?.profile ? (
            profile?.profile?.agent_name ? (
              <Box
                sx={{
                  marginLeft: "3rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {profile?.profile?.badge ? (
                  <Tooltip
                    title={profile?.profile?.badge}
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, -14],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <img
                      style={{ cursor: "pointer ", marginRight: ".25rem" }}
                      width={"56"}
                      src={
                        profile?.profile?.badge
                          ?.toLocaleLowerCase()
                          .includes("gold")
                          ? GoldBadge
                          : profile?.profile?.badge
                              ?.toLocaleLowerCase()
                              .includes("silver")
                          ? SilverBadge
                          : profile?.profile?.badge
                              ?.toLocaleLowerCase()
                              .includes("platinum")
                          ? PlatinumBadge
                          : profile?.profile?.badge
                              ?.toLocaleLowerCase()
                              .includes("bronze")
                          ? BronzeBadge
                          : null
                      }
                    />
                  </Tooltip>
                ) : null}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <Typography
                    sx={{ color: lightMode ? "#000000" : "#ffffff" }}
                    variant="body2"
                  >
                    Welcome
                  </Typography>
                  <Typography
                    sx={{ color: lightMode ? "#444444" : "#ffffff" }}
                    variant={isMobile ? "caption" : "h6"}
                  >
                    {profile?.profile?.agent_name}
                  </Typography>
                </Box>
              </Box>
            ) : null
          ) : (
            <Box sx={{ width: 120, height: 40 }}>
              <Skeleton sx={{ height: "100%" }} animation="wave" />
            </Box>
          )} */}
          {/* ) : null} */}

          {isMobile ? null : (
            <>
              <Box
                ref={profileRef}
                sx={{
                  position: "relative",
                  marginLeft: "2rem",
                  background: `${lightMode ? "#23416a" : "#23416a"}`,
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "100%",
                }}
              >
                <Box
                  sx={{
                    background:
                      "radial-gradient(#FFFFFF, #F5F5F5, #F2F2F2, #E6E6E6, #CCCCCC)",
                    padding: "4px",
                    borderRadius: "100%",
                  }}
                >
                  <Box
                    sx={{
                      cursor: "pointer",
                      background: theme.palette.customRed.orange,
                      width: "44px",
                      height: "44px",
                      borderRadius: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => setPersonShow(!personShow)}
                  >
                    <Typography
                      variant="h5"
                      color={lightMode ? "#fff" : "#fff"}
                    >
                      {profile?.profile?.agent_name
                        ?.split(" ") // kelimelere ayır
                        .map((word) => word[0]) // her kelimenin ilk harfini al
                        .slice(0, 2) // en fazla 3 harf
                        .join("") // birleştir
                        .toUpperCase()}
                    </Typography>

                    {/* <PersonIcon sx={{ fontSize: "32px", color: "#ffffff" }} /> */}
                  </Box>
                </Box>

                {personShow ? (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "60px",
                      right: "0",
                      width: "200px",
                      height: "auto",

                      overflow: "hidden",
                      borderRadius: "1rem",
                      backgroundColor: `rgba(${lightMode ? "255 255 255" : "28 37 46"
                        } / 0.9)`,
                      backgroundImage: `url(${paperBackFirstImg}), url(${paperBackSecondImg})`,
                      backgroundSize: "50%, 50%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right top, left bottom",
                      backdropFilter: "blur(20px)",
                      transition:
                        "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                      outline: 0,
                    }}
                  >
                    <Link
                      onClick={() => setPersonShow(false)}
                      to={!token.accessToken ? "/login" : "/profile"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#000000",
                        textDecoration: "none",
                        borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"
                          }`,
                        padding: ".5rem",
                      }}
                    >
                      <IconButton color="inherit">
                        <SettingsIcon
                          sx={{ color: theme.palette.primary.main }}
                        />
                      </IconButton>
                      <Typography
                        color={lightMode ? "1C252E" : "#fff"}
                        variant="body1"
                      >
                        {t("profile")}
                      </Typography>{" "}
                    </Link>
                    <Link
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#000000",
                        textDecoration: "none",
                        padding: ".5rem",
                      }}
                      onClick={() => {
                        if (localStorage.getItem("accessToken")) {
                          logOutFunc();
                        }
                      }}
                      to={!token.accessToken && "/login"}
                    >
                      <IconButton color="inherit">
                        {token.accessToken ? (
                          <LogoutIcon
                            sx={{ color: theme.palette.primary.main }}
                          />
                        ) : (
                          <LoginIcon
                            sx={{ color: theme.palette.primary.main }}
                          />
                        )}
                      </IconButton>
                      <Typography
                        color={lightMode ? "1C252E" : "#fff"}
                        variant="body1"
                      >
                        {token.accessToken ? t("logOut") : t("logIn")}
                      </Typography>
                    </Link>
                  </Box>
                ) : null}
              </Box>
            </>
            // <Link
            //   onClick={() =>
            //     loginControl.setLoginControl(
            //       !loginControl.loginControl,
            //       loginControl.loginControl && logOutFunc()
            //     )
            //   }
            //   style={{
            //     display: "flex",
            //     alignItems: "center",
            //     color: "#000000",
            //     textDecoration: "none",
            //     marginLeft: "2rem",
            //   }}
            //   to={
            //     localStorage.getItem("loginControl")
            //       ? loginControl.loginControl ||
            //         loginControl.loginControl === undefined
            //         ? `/`
            //         : `/login`
            //       : loginControl.loginControl
            //       ? `/`
            //       : `/login`
            //   }
            // >
            //   <IconButton color="inherit">
            //     {localStorage.getItem("loginControl") ? (
            //       loginControl.loginControl ||
            //       loginControl.loginControl === undefined ? (
            //         <LogoutIcon sx={{color: theme.palette.primary.main}} />
            //       ) : (
            //         <LoginIcon sx={{color: theme.palette.primary.main}} />
            //       )
            //     ) : loginControl.loginControl ? (
            //       <LogoutIcon sx={{color: theme.palette.primary.main}} />
            //     ) : (
            //       <LoginIcon sx={{color: theme.palette.primary.main}} />
            //     )}
            //   </IconButton>
            //   <Typography color={lightMode ? '1C252E' : '#fff'} variant="body1">
            //     {localStorage.getItem("loginControl")
            //       ? loginControl.loginControl ||
            //         loginControl.loginControl === undefined
            //         ? `Log Out`
            //         : `Log In`
            //       : loginControl.loginControl
            //       ? `Log Out`
            //       : `Log In`}
            //   </Typography>
            // </Link>
          )}
        </Toolbar>
      </AppBar>
      <IconButton
        sx={{
          position: "fixed",
          top: "16px",
          left: { xs: open ? drawerWidth - 4 : 32, md: drawerWidth - 4 },
          zIndex: 999999,
          backgroundColor: "white",
          border: "1px solid #e0e0e0",
          borderRadius: "50%",
          width: 32,
          height: 32,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          "&:hover": {
            backgroundColor: "#f5f5f5",
          },
        }}
        edge="start"
        color="default"
        aria-label="open drawer"
        onClick={toggleDrawer}
      >
        <ChevronLeft fontSize="small" sx={{ color: "#666" }} />
      </IconButton>
      <Drawer
        sx={{ position: "sticky", zIndex: "99999", backgroundColor: "green" }}
        variant="permanent"
        open={open}
        lightMode={lightMode}
        drawerWidth={drawerWidth}
      >
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: [1],
            margin: "20px auto",
          }}
        >
          <a
            href="/"
            style={{
              with: "fit-content",
            }}
          >
            <img
              alt="Logo"
              style={{
                marginLeft: "auto",
                marginRight: "auto",
              }}
              width={!open ? (isMobile ? "100" : "30") : "170"}
              src={
                !open
                  ? isMobile
                    ? "https://londonist.co.uk/assets/img/topResidences/logo-londonist.png"
                    : logoMini
                  : lightMode
                    ? "https://londonist.co.uk/assets/img/topResidences/logo-londonist.png"
                    : logoWhite
              }
            />
          </a>

          {/* {open ? (
            <img
              style={{ marginLeft: "auto", marginRight: "auto" }}
              width={100}
              src={logoWhite}
            />
          ) : (
            <img
              style={{ marginLeft: "auto", marginRight: "auto" }}
              width={30}
              height={30}
              src={logoMini}
            />
          )} */}

          {/* <IconButton onClick={toggleDrawer}>
            <ChevronLeftIcon sx={{ color: "#ffffff" }} />
          </IconButton> */}
        </Toolbar>
        <SimpleBar style={{ maxHeight: "calc(100vh - 100px)" }}>
          <List
            component="nav"
            sx={{
              padding: "1rem",
            }}
          >
            <MainListItems open={open} setOpen={setOpen} />
          </List>
        </SimpleBar>
      </Drawer>

      {isMobile && (
        <CustomBackdrop
          open={open}
          onClick={toggleDrawer} // Bu, backdrop'a tıklanıldığında drawer'ı kapatacaktır.
        />
      )}

      <Box
        component="main"
        data-main-content
        sx={{
          // backgroundColor: (theme) =>
          //     theme.palette.mode === 'light'
          //         ? theme.palette.grey[100]
          //         : theme.palette.grey[900],
          background: lightMode
            ? isDashboard
              ? "#fffffe"
              : "#fffffe"
            : "#1e1e1e",
          flexGrow: 1,
          minWidth: isMobile && open ? "100vw" : 0,
          maxWidth:
            open && !isMobile
              ? `calc(100% - ${drawerWidth}px)`
              : !isMobile
              ? "calc(100% - 56px)"
              : "100%",
          minHeight: "100vh",
          overflow: isMobile && open ? "hidden" : "auto",
          // marginLeft: theme.spacing(0),
          // [theme.breakpoints.up("sm")]: {
          //   marginLeft: `${drawerWidth}px`,
          // },
          marginLeft:
            open && !isMobile ? `${drawerWidth}px` : !isMobile ? "56px" : "0px",
          transition: "margin-left .34s",
        }}
      >
        <Toolbar />
        <Container maxWidth={"xl"} sx={{ mt: 4, mb: 8 }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
}
